module.exports = __webpack_public_path__ + "img/02.76d7f06e.jpg";